import React, { useState } from "react";
import insytix_logo from "../assets/insytix_logo.png";
import techInstitute_logo from "../assets/TechInstitutelogo.png";
import { FaBars, FaTimes } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import Button from "./UI/Button";
import Contact from "../pages/contact/Contact";
import Project from "../pages/product/Project";
import { Link, useLocation } from "react-router-dom";

const Navbar: React.FC = () => {
  const [nav, setNav] = useState(false);
  const location = useLocation();
  
  const items = [
    {
      id: 1,
      item: "Home",
      path: "",
    },
    {
      id: 2,
      item: "Services",
      path: "/service",
    },
    {
      id: 3,
      item: "Products",
      path: "/ourProducts",
    },
    {
      id: 4,
      item: "About us",
      path: "/aboutUs",
    },
    {
      id: 5,
      item: "Our team",
      path: "/ourTeam",
    },
    {
      id: 6,
      item: "Careers",
      path: "/career",
    },
    {
      id: 7,
      item: "Tech Institute",
      path: "/techInstitute",
    },
  ];

  const isActive = (path: string) => {
    if (path === "") {
      return location.pathname === "/" || location.pathname === "";
    }
    return location.pathname === path;
  };

  // Check if current page is Tech Institute
  const isTechInstitutePage = location.pathname === "/techInstitute";

  return (
    <>
      <div className="  h-20 flex justify-between px-3 sm:px-10 items-center bg-white shadow-md ">
        <div>
          <Link
            to={""}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            <img 
              src={isTechInstitutePage ? techInstitute_logo : insytix_logo} 
              className=" h-48   w-48" 
              alt="" 
            />
          </Link>
        </div>
        <div className="hidden md:flex sm:gap-4 lg:gap-8">
          <ul className="flex items-center md:gap-6 cursor-pointer">
            {items.map(({ id, item, path }) => (
              <Link
                to={path}
                key={id}
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                <li className={`hover:scale-125 transition-all duration-300 ${
                  isActive(path) && item === "Tech Institute"
                    ? `px-4 py-2 rounded-lg bg-blue-500 text-white border-2 border-blue-500`
                    : item === "Tech Institute"
                    ? `px-4 py-2 rounded-lg border-2 border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300`
                    : isActive(path)
                    ? `text-blue-500 font-semibold`
                    : ""
                }`}>
                  {item}
                </li>
              </Link>
            ))}
          </ul>

          <Link to="contactUs">
            <Button className="bg-blue-500 text-white p-3 rounded-md">
              Contact us
            </Button>
          </Link>
        </div>
        <div className="md:hidden z-50" onClick={() => setNav(!nav)}>
          {nav ? (
            <FaTimes size={30} className="text-white" />
          ) : (
            <FaBars size={30} />
          )}
        </div>
        {nav && (
          <ul
            className={`fixed top-0 right-0 z-40 pt-5 pl-5 w-60 h-screen bg-black text-white  ${
              nav ? "animate-slide-in-left" : ""
            } `}
          >
            {items.map(({ id, item, path }) => (
              <Link to={path} key={id}>
                <li className={`text-xl p-3 hover:text-gray-500 ${
                  isActive(path) && item === "Tech Institute"
                    ? `px-4 py-2 rounded-lg bg-blue-500 text-white border-2 border-blue-500`
                    : item === "Tech Institute"
                    ? `px-4 py-2 rounded-lg border-2 border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300`
                    : isActive(path)
                    ? `text-blue-500 font-semibold`
                    : ""
                }`}>
                  {item}
                </li>
              </Link>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default Navbar;
